module.exports = __webpack_public_path__ + "static/money1-afc7029295ea680b0674aa434481aae8.png";